<!--
  a11y: audit required this card to be reachable AND understandable by SR
  users on the POI results page. Changes:
   - The card is exposed as a <section> (landmark of "region" / "group"-
     style content) with role="group" and aria-label that bundles the
     station name + code + lines count into a single announcement, so SR
     reads the whole card identity up-front before its inner content.
   - aria-posinset / aria-setsize tell SR "card 2 of 7" while walking the
     parent <ul>.
   - The station name is promoted to <h3> so SR's heading navigation jumps
     between station cards quickly (the dialog's existing <h2>s are the
     slide-up title and the POI name).
   - The decorative station icon is hidden from AT (ng-icon already sets
     aria-hidden, but the inline svg may not; we add aria-hidden on the
     wrapper to be safe).
   - The outer (click) handler that emits onFoucs (which highlights the
     station on the map) is preserved for mouse users but is NOT exposed
     as a keyboard/SR action - the card is not focusable on purpose. The
     real "go to station details" action lives on the bottom "Extended
     details" button (mot-button below), which IS in the tab order.
-->
<section
  role="group"
  class="flex flex-col gap-2 items-start border border-solid border-[#B4BFCB] rounded-xl w-full boxshadow2"
  [class]="direction"
  [attr.aria-label]="cardAriaLabel"
  [attr.aria-posinset]="positionInSet || null"
  [attr.aria-setsize]="setSize || null"
  (click)="$event.stopPropagation(); onFoucs.emit(station);"
  >
  <div class="flex gap-2 items-center h-[3.625rem] px-3">
    <ng-icon name="station" class="!text-xl colored-icon" aria-hidden="true" />
    <div class="flex flex-col text-sm">
      <h3 class="text-sm m-0 font-medium">{{ stationName }}</h3>
      <span class="font-normal text-sm text-[#5C748F]"
        >{{ stationCodeText }}: {{ station.stopcode }}</span
        >
      </div>
    </div>
    <app-stations-result-list-item-lines [routes]="station.routesInStop" />
    <div class="flex items-center py-1 h-[2rem] gap-2">
      @if (specialMessagesCounter > 0) {
        <div class="flex items-center gap-2">
          <div class="flex items-center">
            <mot-button
              [icon]="'message-exclamation'"
              [text]="specialMessagesText"
              [ariaLabel]="specialMessagesAriaLabel"
              ariaHaspopup="dialog"
              (onClick)="openSpecialMessages(); $event.stopPropagation()"
              />
              <app-special-messages-counter
                [messagesCounter]="specialMessagesCounter"
                />
              </div>
              @if (isStationCancled) {
                <div
                  class="flex items-center justify-center min-w-[5.5rem] h-[1.25rem] bg-[#D4282E] rounded-lg text-white font-normal text-xs"
                  >
                  <span class="text-white font-normal text-xs">{{
                    stationCancelledText
                  }}</span>
                </div>
              }
            </div>
          }
          @if (station.isAlternativeStation) {
            <div
              class="flex items-center justify-center min-w-[5.5rem] h-[1.25rem] mx-2 bg-[#008667] rounded-lg text-white font-normal text-xs"
              >
              <span class="text-white font-normal text-xs">{{
                alternativeStationText
              }}</span>
            </div>
          }
        </div>
        <mot-button
          [icon]="'info'"
          class="w-full bg-transparent border border-solid border-b-0 border-r-0 border-l-0 border-[#B4BFCB]"
          buttonClass="w-full text-center"
          [text]="extendedDetailsText"
          [ariaLabel]="extendedDetailsAriaLabel"
          (onClick)="onPickStation.emit()"
          />
        </section>
